import axios from '../axios'
import { getURL, jsonToParam } from 'src/utils/config';
import { handleResponse } from 'src/utils/responseHandler';

// get cameras data
const getClientContact = (callback) => {
    axios({
        method: 'get',
        url: `${getURL('/protocols/get-client-contacts')}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}




const setClientContacts = (body,callback) => {
    axios({
        method: 'post',
        url: getURL('/protocols/add-client-contacts'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const postClientContacts = (body,callback) => {
    axios({
        method: 'put',
        url: getURL('/protocols/update-client-contact'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const deleteClientContacts = (Id, callback) => {
    axios({
        method: 'delete',
        url: getURL('/protocols/delete-client-contact'),
        data: Id,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const getClientEscalatedVideos = (data,callback) => {
    const { camera_id, start_time , end_time } = data; 
    axios({
        method: 'get',
        url: `${getURL('/recordings')}?camera_id=${camera_id}&start_time=${start_time}&end_time=${end_time}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getEscalatedSummary = (data,callback) => {
    const { camera_id, start_time, end_time } = data; 
    axios({
        method: 'get',
        url: `${getURL('/recordings/summary-by-camera')}?camera_id=${camera_id}&start_time=${start_time}&end_time=${end_time}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getCameraCount = (data,callback) => {
    const {fromdate,todate, location_id, property_id, event_category } = data;
    
    let url = `${getURL('/dashboard/escalated-audit-counts-per-camera')}?fromdate=${fromdate}&todate=${todate}&location_id=${location_id ? location_id :0}`;
    if (property_id) {
        url += `&property_id=${property_id}`;
    }
    if (event_category) {
        url += `&event_category=${event_category}`;
    }
    axios({
        method: 'get',
        url: url,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getAudioByEvent = (body,callback) => {
    axios({
        method: 'get',
        // url: `${getURL('devices')}?${jsonToParam(body)}`,
        url: `${getURL('/client-info/get-announcements-by-eventno')}?${jsonToParam(body)}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))

    // const { eventNumber } = data; 
    // axios({
    //     method: 'get',
    //     url: `${getURL('/client-info/get-announcements-by-eventno')}?event_no=${eventNumber}`,
    //     validateStatus: (status) => handleResponse(status)
    // }).then((response) => callback(response))
}

const getvideoURLMail = (data,callback) => {
    const { to, client_name , video_url , type} = data; 
    axios({
        method: 'get',
        url: `${getURL('/client-reports/send-video-detail')}?to=${to}&client_name=${client_name}&video_url=${video_url}&type=${type}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getDashboardEventSummary = (data,callback) => {
    const {fromdate,todate, location_id, property_id, event_category } = data;
    
    let url = `${getURL('/dashboard/events-summary')}?fromdate=${fromdate}&todate=${todate}&location_id=${location_id ? location_id : 0}`;
    if (property_id) {
        url += `&property_id=${property_id}`;
    }
    if (event_category) {
        url += `&event_category=${event_category}`;
    }

    return axios({
        method: 'get',
        url: url,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getClientAudits = (data,callback) => {
    const {fromdate,todate,limit,location_id, property_id, event_category } = data;
    let url = `${getURL('/client-info/get_client_audits')}?limit=${limit || 3}&location_id=${location_id ? location_id :0}`
    if (fromdate) {
        url += `&fromdate=${fromdate}`;
    }
    if (todate) {
        url += `&todate=${todate}`;
    }
    if (property_id) {
        url += `&property_id=${property_id}`;
    }
    if (event_category) {
        url += `&event_category=${event_category}`;
    }
    axios({
        method: 'get',
        url: url,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getChartCount = (data,callback) => {
    const {type, location_id, property_id, event_category } = data; 
    let url = `${getURL('/dashboard/priority-count')}?type=${type}&location_id=${location_id ? location_id :0}`
    if (property_id) {
        url += `&property_id=${property_id}`;
    }
    if (event_category) {
        url += `&event_category=${event_category}`;
    }
    axios({
        method: 'get',
        url: url,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const getClientCameras = (bodyParams, callback) => {
    axios({
        method: 'get',
        url: Object.keys(bodyParams).length > 0
            ? `${getURL('/devices')}?${bodyParams}`
            : `${getURL('/devices')}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}



const postEventstatus = (body,callback) => {
    axios({
        method: 'put',
        url: getURL('/client-info/client-event-status'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}



export {getChartCount,getCameraCount, getClientContact ,setClientContacts ,postClientContacts ,deleteClientContacts ,getClientEscalatedVideos ,getAudioByEvent ,getvideoURLMail,getEscalatedSummary,getDashboardEventSummary,getClientAudits,getClientCameras ,postEventstatus}
